module.exports = __webpack_public_path__ + "img/37260-040.fcb892d9.jpg";